import React from "react";
import Footer from "../components/Footer";
import NavBar from "../components/NavBar";
import GymPodDetails from "../components/GymPodDetails";

const GymPod = () => {
  return (
    <>
      {/* Navigation Bar */}
      <NavBar />

      {/* Gym Pod Details Area */}
      <GymPodDetails />

      {/* Footer One */}
      <Footer />
    </>
  );
};

export default GymPod;
